<template>
    <v-app>
        <NavBar ref="navBar"
                v-if="isTransCamPage" style="width: 250px" />
     
        <v-main>
            <router-view v-slot="{ Component }">
                <component :is="Component"
                           v-if="$route.name === 'TransCAM'"
                           ref="transCamRef" />
                <component :is="Component"
                           v-else />
            </router-view>
        </v-main>

        <DialogSituationCPS
            v-model="popupSituationCPS"
            :cps="blocsSituationEnAttente"
            @choisir="onSituationChoisie"
            @annuler="onSituationAnnulee" />

        <DialogSaisiePin />
    </v-app>
</template>
<script>
    import Connexion from '@/script/Connexion'
    import Grid from './components/Grid.vue'
    import FicheDescriptive from './components/FicheDescriptive.vue'
    import Recherche from './components/Recherche.vue'
    import FisimedClient from './components/FisimedClient.vue'
    import Accueil from './components/Accueil.vue'
    //import ChoixAppli from './components/ChoixAppli.vue'
    import Home from './components/Home.vue'
    import About from './components/About.vue'
    import NotFound from './components/NotFound.vue'
    import Flic32 from './components/Flic32.vue'
    import NavBar from './components/NavBar.vue'
    import Loader from './components/Loader.vue'
    import TransCAM from './components/TransCam/TransCAM.vue'
    import EtatConnexion from "./components/EtatConnexion.vue";
    import DialogSituationCPS from '@/components/DialogSituationCPS.vue';
    import DialogSaisiePin from '@/components/DialogSaisiePin.vue';
    //import PopUpConfirmation from './components/PopUpConfirmation.vue'
    import config from "./config.js";
    import axios from 'axios';
    import { isProxy, toRaw } from 'vue';
    import RequestManager from "./script/request.js";
    import router from "./routeur.js"
    import store from "./store.js"
    import Patient from './script/Patient'
    import Assertion from './script/Assertion'
    import Fse from './script/Fse';
    import * as pinCps from '@/script/pinCps';
    import { mapActions } from 'vuex';
    import { mapGetters } from 'vuex';



    //function receiveDataFromXamarin(dataStr) {
    //    //alert('Données reçues ' + dataStr);
    //    alert('receiveDataFromXamarin');
    //    this.$store.dispatch('SSV/receiveDataFromXamarinObject', JSON.parse(dataStr));
    //    //document.body.app.receiveDataFromXamarinObject(JSON.parse(dataStr));
    //}

    export default {
        name: 'App',
        components: {
            Connexion,
            EtatConnexion,
            Recherche,
            FisimedClient,
            Accueil,
            //ChoixAppli,
            NavBar,
            Loader,
            TransCAM,
            DialogSituationCPS,
            DialogSaisiePin,

            /*PopUpConfirmation*/
        },
        data() {
            return {
                connecte: false,
                fisimedClient: false,
                token: "",
                isLoading: "false",
                popupSituationCPS: false,
                blocsSituationEnAttente: null,
                suiteApresChoixSituation: null,
            }
        },

        computed: {
            //getSaisiefse() {
            //    ...mapGetters('SSV', ['getIndexBenefActif']),
            //},

            ...mapGetters('SSV', ['getIndexBenefActif']),
            ...mapGetters("Cartes", ['nbTentative']),
            benef() {
                return this.carteVitale.benef
            },
            connexionValeur() {
                return this.$store.getters["ConnexionStore/getConnexionValeur"];
            },
            appliLaunched() {
                return this.$store.getters["ConnexionStore/getAppliLaunched"];
            },
            appliLance() {
                return this.$store.getters["ConnexionStore/getAppliLance"];
            },
            requestManager() {
                const res = this.$store.getters["requestManager/getRequestManager"];
                if (isProxy(res)) {
                    const raw = toRaw(res);
                    console.log(raw);
                    return raw;
                }
                return res;
            },
            isConnexionPage() {
                return this.$route.path === '/';
            },
            // La NavBar (barre laterale TransCAM) ne doit apparaitre que dans l'appli TransCAM
            // (route 'TransCAM' et ses enfants /transcam/..., /transCam/parametre).
            isTransCamPage() {
                return this.$route.path.toLowerCase().startsWith('/transcam');
            }
        },


        methods: {
            replaceTypeByGroup(jsonString) {
                // 1️⃣ On parse la chaîne JSON si nécessaire
                let data = typeof jsonString === "string" ? JSON.parse(`[${jsonString}]`) : jsonString;
                // 2️⃣ On crée un nouveau tableau avec la clé remplacée
                const modified = data.map(item => {
                    const { Type, ...rest } = item;
                    return { group: Type, ...rest };
                });
                // 3️⃣ On retourne l'objet modifié
                return modified;
            },

            allerVersErreurs() {
                this.$router.push({ name: "ErreursTransCAM" })
            },
            verifierConnectionEtRedirigerVersTransCAM() {
                const Token = localStorage.getItem("Token");

                RequestManager.setToken(Token);
                RequestManager.instance.interceptors.response.use(
                    function (response) {
                        return response;
                    },
                    function (error) {
                        console.log(error.response)
                        if (error.response && error.response.status === 401) {
                            store.dispatch("ConnexionStore/deconnexion");
                            router.push({ name: 'Accueil' });
                        }
                        return Promise.reject(error);
                    }
                );
                this.$nextTick(() => {
                    console.log("refs:", this.$refs);
                });
                if (this.estSessionLoginFisi()) {
                    this.redirigerVersChoixApplicationQuandDejaConnecte();
                }
                else {
                    this.redirigerVersTransCamQuandDejaConnecte();
                }
            },
            chercherErreurAffichableDansleBack() {

            },
            lireCPS() {
                //RequestManager.EnvoyerMessageWebView({ action: "LireCartePS", parameters: ["1234"] });
                console.log("lireCPS refs = ", this.$refs);
                console.log("ireCPS refs.transCamRef = ", this.$refs.transCamRef)
                this.$refs.transCamRef.afficherPopUpCPS();
            },
            lireVitale() {
                //RequestManager.EnvoyerMessageWebView({ action: "LireCarteVitale", parameters: ["1234"] });
            },
            ...mapActions('SSV', ['setIndexBenefActif']),
            estSessionLoginFisi() {
                return localStorage.getItem('redirigerVersChoixApplicationQuandDejaConnecte') === 'true';
            },
            redirigerVersChoixApplicationQuandDejaConnecte() {

                if (localStorage.hasOwnProperty('Token')) {
                    Connexion.connecterWithToken()
                        .then(response => {
                            if (response != undefined) {
                                this.$store.dispatch("ConnexionStore/setConnexion", response);
                                if (response.success) {
                                    this.$router.push({ name: "ChoixAppli" });
                                }
                            }
                        })
                }
            },
            redirigerVersTransCamQuandDejaConnecte() {

                if (localStorage.hasOwnProperty('Token')) {
                    Connexion.connecterWithToken()
                        .then(response => {
                            if (response != undefined) {
                                this.$store.dispatch("ConnexionStore/setConnexion", response);
                                if (response.success) {
                                    this.$router.push({ name: "TransCAM" });
                                }
                            }
                        })
                }
            },
            onTest() {
                RequestManager.get(config.urlSubBackEnd + "/Values/Get")
                    .then(response => console.log(response))
                    .catch(error => console.log(error));
            },
            actualiserPageSansCache() {
                location.reload(true);
            },
            //changerPage() {
            //    this.$router.push({ name: "ChoixAppli" });
            //},
            testAPI() {
                var url1 = "https://localhost:44361/api/values/"
                var url2 = "https://82.127.136.182:22123/ASPSite2/api/values/"
                fetch("https://82.127.136.182:22123/api/values")
                    .then(response => { return response.json() })
                    .then(data => { console.table(data); alert("Excellent!"); alert(data[0]); })
                    .catch(error => { alert("Erreur lors de fetch") });
            },
            testIP() {
                fetch('https://api.ipify.org?format=json')
                    .then(response => { return response.json() })
                    .then(data => { console.log(data); alert("IP: " + data.ip) })
                    .catch(error => { console.error(error) });
            },
            deconnexion() {
                this.$store.dispatch('ConnexionStore/deconnexion');
            },
            //retourChoixAppli() {
            //    this.$store.dispatch("ConnexionStore/setAppliLance", "");
            //    this.$router.push({ name: "ChoixAppli" });
            //},
            setCPS() {
                alert('CarteCPS');
            },

            // Traite les blocs d'une lecture CPS complete : 0/1 situation -> chargement
            // direct ; >=2 -> popup de choix. `apres` = callback jouee apres chargement.
            async traiterLectureCPS(blocs, apres) {
                const situs = Array.isArray(blocs) ? blocs.filter(b => b && (b.group === 2 || b.Type === 2)) : [];
                if (situs.length >= 2) {
                    this.blocsSituationEnAttente = blocs;
                    this.suiteApresChoixSituation = apres || null;
                    this.popupSituationCPS = true;
                    return; // la suite se joue dans onSituationChoisie
                }
                await this.$store.dispatch('Cartes/setCarteCPS', { carte: blocs, situation: 1 });
                if (apres) await apres();
            },

            async onSituationChoisie(index) {
                const blocs = this.blocsSituationEnAttente;
                const apres = this.suiteApresChoixSituation;
                this.blocsSituationEnAttente = null;
                this.suiteApresChoixSituation = null;
                await this.$store.dispatch('Cartes/setCarteCPS', { carte: blocs, situation: index });
                if (apres) await apres();
            },

            onSituationAnnulee() {
                // Aucune situation activee : on n'envoie pas de SetCPS. L'utilisateur devra
                // relire la carte. (Port de choixsitucps Command2, sans arret de l'appli.)
                this.blocsSituationEnAttente = null;
                this.suiteApresChoixSituation = null;
                this.$store.commit('Cartes/setErreurCodeCPS', true);
            },

            //receiveDataFromXamarin(dataStr) {
            //    //alert('Test2');
            //    //alert('Données reçues ' + dataStr);
            //    this.receiveDataFromXamarinObject(JSON.parse(dataStr));
            //},

            async receiveDataFromXamarinObject(data) {

                //Attention : utiliser window.store et window.router

                // Faites quelque chose avec les données reçues de Xamarin
                //console.log('Données reçues depuis Xamarin : ' + data);
                //alert('Données reçues depuis Xamarin : receiveDataFromXamarinObject');
                //alert('Données reçues depuis Xamarin : ' + data.action);
                if (data.action == 'Message') {
                    alert(data.parameters[0]);
                }
                else if (data.action == 'InitialiserLienWebView') {
                    //Premier paramètre : EstBrowser ("true" = navigateur, sinon webview telephone)
                    RequestManager.avecWebView = true;
                    if (data.parameters[0] == "true") {
                        RequestManager.estMobile = true;
                    }
                    else {
                        RequestManager.estMobile = false;
                    }
                    this.initialiserWebView();
                }
                else if (data.action == 'identifiantsEnregistres') {
                    // Identifiants renvoyes par le natif (SecureStorage) -> dispo pour preremplir le login
                    this.$store.commit('ConnexionStore/setIdentifiantsMobile', {
                        id: data.parameters && data.parameters[0] ? data.parameters[0] : '',
                        mdp: data.parameters && data.parameters[1] ? data.parameters[1] : ''
                    });
                }
                else if (data.action == 'Info') {

                }
                else if (data.action == 'Erreur') {
                    alert('Erreur : ' + data.parameters[0]);
                }
                else if (data.action == 'Version') {

                }
                else if (data.action == 'CarteCPS') {
                    await this.traiterLectureCPS(data.parameters);
                }
                else if (data.action == 'CarteCPSInscription') {
                    //alert("Dans app.vue -> CarteCPSInscription")
                    this.$store.commit('Cartes/setCarteCPS', data.parameters);
                    if (data.parameters == "") {
                        this.$store.commit('Cartes/setErreurCodeCPS', true);

                    }
                    else {
                        //alert("Le code PIN de la carte est bon!!!\n La carte PS a bien été lue")
                    }
                }
                else if (data.action == 'CarteCPSConnexion') {
                    //alert(JSON.stringify(data));
                    //alert("Dans App.vue CarteCPSConnexionDans App.vue CarteCPSConnexion")Début dans Accueil.vue watch : getCartePS
                    this.$store.commit('Cartes/setCarteCPS', data.parameters);
                    console.log("App.vue CarteCPSConnexionDans data.parameters ", data.parameters)
                    if (data.parameters == "") {
                        this.$store.commit('Cartes/setErreurCodeCPS', true);
                    }
                    else {
                        //alert("Le code PIN de la carte est bon!!!\n La carte PS a bien été lue")
                    }
                }
                else if (data.action == 'CarteCPSRelecture') {
                    console.log("dans app.vue CarteCPSRelecture data = ", data);
                    if (data.parameters == "") {
                        this.$store.commit('Cartes/setErreurCodeCPS', true);
                        alert("setErreurCodeCPS app.vue CarteCPSRelecture ")
                    }
                    else {
                        await this.traiterLectureCPS(data.parameters, async () => {
                            await this.$store.dispatch('Cartes/chargerCarteCPS');
                            this.$refs.navBar.fermerPopup();
                            this.$router.push({ name: "Fse" });
                        });
                    }
                }
                else if (data.action == 'CarteCPSLireVitale') {
                    if (data.parameters == "") {
                        this.$store.commit('Cartes/setErreurCodeCPS', true);
                    }
                    else {
                        await this.traiterLectureCPS(data.parameters, async () => {
                            let code = this.$refs.navBar.$refs.popupCodeCPS.code;
                            RequestManager.EnvoyerMessageWebView({ action: "LireCarteVitale", parameters: [code] });
                            this.$refs.navBar.fermerPopup();
                        });
                    }
                }
                else if (data.action == 'CarteCPSLectureError') {
                    console.log("App.vue CarteCPSLecteurError data.parameters = ", data.parameters)
                    if (data.parameters[0] == "Error : 61441") {
                        alert("Carte CPS non insérée");
                    }
                    else if (data.parameters[0] == "Error : 61442") {
                        alert("Carte CPS Bloquée");
                    }
                    else if (data.parameters[0] == "Error : 61443") {
                        alert("Code CPS incorrect");
                    }
                    else {
                        alert("Erreur non traitée : " + data.parameters[0]);
                    }
                    this.$store.commit("Cartes/decrementerNbTentativeDuCodeCPS");
                }
                else if (data.action == 'CarteVitale') {
                    console.log("CarteVitale --> ", data.parameters);
                    const jsonString = data.parameters;
                    let data2 = typeof jsonString === "string" ? JSON.parse(`[${jsonString}]`) : jsonString;
                    // 2️⃣ On ajoute "group" (= Type) SANS supprimer "Type" : le backend SetVitale
                    // lit lis[i].Type (== 104 pour les beneficiaires). Le renommer en "group"
                    // mettait Type a 0 cote backend -> aucun beneficiaire detecte.
                    const modified = data2.map(item => ({ group: item.Type, ...item }));
                    console.log("modified = ", modified);
                    this.$store.dispatch('SSV/setCarteVitale', modified);
                    this.$router.push('/transcam/LireCarteVitale');
                    //alert("Lire Vitale");
                }
                else if (data.action == 'SignaturePoint') {
                    this.$store.commit('ParametreOptionPraticien/SetSignaturePoints', data.parameters);
                    if (data.parameters == "") {
                        this.$store.commit('ParametreOptionPraticien/ErrorSetSignaturePoints', true);
                    }
                }
                else if (data.action == 'sendAssertionCPS') {
                    Assertion.setAssertionPS(data.parameter);
                }
                else if (data.action == 'sendLoadedAssertions') {
                    console.log(data.parameter);
                    Assertion.setAssertionVitaleAndPS(data.parameter)
                        .then(response => {
                            console.log("response Assertion.setAssertionVitaleAndPS = ", response);
                            if (response["assertionPsSaved"] && response["assertionVitaleSaved"]) {
                                Assertion.generateAdrResponseAndImtResponse(this.getIndexBenefActif)
                                    .then(async (response) => {
                                        console.log("Dans App.vue sendLoadedAssertions");
                                        await this.$store.dispatch("ChoixBenecStore/fetchEtatADR");
                                        // IMT (medecin traitant) : l'appel tourne sur un thread de fond
                                        // cote lib -> on poll le resultat pour NewFSE (zone parcours).
                                        this.$store.dispatch("ChoixBenecStore/pollReponseIMT");
                                    });
                            }
                        })
                        .catch(error => { console.error(error) });
                }
                else if (data.action == 'LireCarteVitaleAPCV') {
                    Assertion.generateApcvResponse(data.parameters[0]).then(response => {
                        console.log("response Assertion.LireCarteVitaleAPCV = ", response);
                        this.$store.dispatch('SSV/setCarteVitaleDirect', response);
                        this.$router.push('/transcam/LireCarteVitale');
                    })
                    .catch(error => { console.error(error) });
                }
                else if (data.action == 'OpenOrCreatePatient') {
                    this.affichePatientEtCreeSiBesoin(data.parameter, true);
                }
                else if (data.action == 'LireAMC') {
                    // AMC / mutuelle scannee cote natif (camera, drag-drop, lecteur serie).
                    // parameter = { numeroAMC, CSR, numeroAdherent, typeConvention }.
                    // On la met en attente : l'ecran Complementaire la consomme (remplissage
                    // direct s'il est ouvert, sinon ouverture pre-remplie en TP complementaire).
                    const p = data.parameter || {};
                    const infosAmc = {
                        numeroAMC: p.numeroAMC || p.NumeroAMC || '',
                        csr: p.CSR || p.csr || '',
                        numeroAdherent: p.numeroAdherent || p.NumeroAdherent || '',
                        typeConvention: p.typeConvention || p.TypeConvention || '',
                    };
                    this.$store.dispatch('FSEHandler/traiterAmcScannee', infosAmc);
                }
                else if (data.action == 'LireMedicament') {
                    // Plomberie en place ; comportement metier (recherche produit / ordonnance)
                    // a definir. parameter = { cip, datePeremption, numeroLot }.
                    console.log('LireMedicament (plomberie) :', data.parameter);
                    this.$store.commit('FSEHandler/setLectureGeneriqueEnAttente', { type: 'medicament', data: data.parameter });
                }
                else if (data.action == 'LireEprescription') {
                    // Plomberie en place ; comportement metier a definir.
                    // parameter = { idPresc, infosIdentite }.
                    console.log('LireEprescription (plomberie) :', data.parameter);
                    this.$store.commit('FSEHandler/setLectureGeneriqueEnAttente', { type: 'ePrescription', data: data.parameter });
                }
                else if (data.action == 'LireRPPS') {
                    // Plomberie en place ; comportement metier a definir. parameters[0] = rpps.
                    console.log('LireRPPS (plomberie) :', data.parameters && data.parameters[0]);
                    this.$store.commit('FSEHandler/setLectureGeneriqueEnAttente', { type: 'rpps', data: data.parameters && data.parameters[0] });
                }
                else if (data.action == 'ChallengeCPSSigne') {
                    // Retour de signature du challenge CPS par le natif : l'assertion SAML
                    // signee par la carte (ou "" / "Error" en cas d'echec). Relais via le
                    // store Cartes -> Accueil.vue (watch getChallengeSigne) poste au backend.
                    this.$store.commit('Cartes/setChallengeSigne', data.parameters);
                }
                else if (data.action == 'StatutCPS') {
                    // Reponse du natif : statut cryptoki de la CPS (0..3) -> resout la promesse pinCps.
                    pinCps.recevoirStatutCPS(data.parameters && data.parameters[0]);
                }
                else if (data.action == 'VoiceCommand') {
                    const texte = data.parameters[0];
                    fetch(`${config.urlBackEnd}/api/voice-command`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ text: texte })
                    })
                    .then(res => res.json())
                    .then(result => {
                        if (result.action) {
                            // Exécuter l'action retournée par le backend
                        }
                    })
                    .catch(err => console.error('Erreur voice command:', err));
                }
                else {
                    alert('Données reçues depuis Xamarin : ' + data.action);
                }
            },

            async affichePatientEtCreeSiBesoin(parametresPatient, creation) {
                //this.patientActuel = {};
                //await Patient.getPatientBySearch("dupre");//
                let response =  await Patient.getPatientByInfos(parametresPatient);
                //RequestManager.post(`${config.urlBackEnd}/Patient/getPatientByInfos`, parametresPatient).then(response => {
                    if (response == null) {
                        console.log("pas de patient");
                        if ((parametresPatient.ins.length > 0) && creation) {
                            // Ajouter le patient
                            let pat = [{
                                numAssu: parametresPatient.ins.slice(0, 13),
                                cle: parametresPatient.ins.slice(-2),
                                nirCertifie: "",
                                cleNirCertifie: "",
                                date: parametresPatient.dateDeNaissance,
                                rangGem: "1",
                                codeCaisse: "",
                                codeCentre: "",
                                codeRegime: "01",
                                nom: parametresPatient.nomFamille,
                                prenom: parametresPatient.prenoms,
                                //sexe: parametresPatient.genre,
                                codeLieuNaissance: parametresPatient.lieuNaissance,
                            }]
                            Patient.enregistrerNouveauPatient(pat).then(response => {
                                console.log("response Patient.enregistrerNouveauPatient = ", response);
                                if (response == "OK") {
                                    console.log("Le patient a été enregistré avec succès !");
                                    this.affichePatientEtCreeSiBesoin(parametresPatient, false); // Rappel de la fonction pour afficher le patient)
                                    return;
                                } else {
                                    console.error("Erreur lors de l'enregistrement du patient : ", response.message);
                                }
                            }).catch(error => {
                                console.error("Erreur lors de l'enregistrement du patient : ", error);
                            });
                        }
                        console.log("Patient non trouvé");
                        //const response = await Patient.enregistrerNouveauPatient(pat);
                        //    await delay(2000);
                        //    if (response != "") {
                        //        console.log("Erreur lors de l'ajout du nouveau patient : " + response);
                        //    } else {
                        //        console.log("Le patient a été enregistré avec succès !");
                        //}
                        this.$router.push('/transcam/Patient');
                    }
                    else {
                        //this.patientActuel = JSON.parse(JSON.stringify(response));
                        //this.patientActuel = response;
                        //console.log("Response Clean = " + this.patientActuel);// JSON.stringify(response));
                        //console.log("Response = " + response);// JSON.stringify(response));
                        //console.log("Response stringify = " + JSON.stringify(response));
                        //console.log("affiche patient response : " + response.data);
                        //console.log("affiche patient  : ", this.patientActuel);
                        //this.$store.dispatch('SSV/setPatient', response);

                        this.$router.push({ path: '/transcam/Patient', query: { setPatient: JSON.stringify(response) } });
                        //response.json().then(data => {
                        //    console.log("response Patient.getPatientByInfos = ", data);
                        //    //this.$store.dispatch('SSV/setPatient', data.patient);
                        //    this.$router.push('/transcam/Patient');
                        //});
                    }
                //})
            },

            initialiserWebView() {
                RequestManager.EnvoyerMessageWebView({ action: "Version", parameters: ["rien", "tout"] });
                RequestManager.EnvoyerMessageWebView({ action: "InitialiserLecteur", parameters: [] });
                // Demande au natif les identifiants enregistres (SecureStorage) pour preremplir le login
                RequestManager.EnvoyerMessageWebView({ action: "demanderIdentifiants", parameters: [] });
            },
        },
        mounted() {
            // [TEST] Expose les VRAIES instances singleton de l'app (RequestManager, pinCps, store)
            // pour piloter les tests CDP (round-trip StatutCPS, flux PIN) sur l'etat reel.
            // Jamais accessible au public :
            //  - en DEV local : actif directement ;
            //  - en PROD : seulement si l'IP client est autorisee -> portillon Nginx /__debughook
            //    (whitelist cote serveur : 200 pour nos IP, 403 sinon). La whitelist se modifie
            //    cote Nginx sans rebuild du front.
            const exposerHookTest = () => {
                try { window.__ccTest = { RequestManager, pinCps, store: this.$store }; } catch (e) { /* noop */ }
            };
            if (import.meta.env.DEV) {
                exposerHookTest();
            } else {
                fetch('/__debughook')
                    .then(r => { if (r.ok) exposerHookTest(); })
                    .catch(() => { /* endpoint absent / non autorise -> pas de hook */ });
            }
        },
        created() {
            if (window.chrome != undefined) {
                if (window.chrome.webview != null) {
                    window.chrome.webview.addEventListener('message', event => {
                        //alert(event.data.action);
                        if (event.data.action == 'Message') {
                            alert(event.data.parameters[0]);
                        }
                        RequestManager.estBrowser = true;
                        this.receiveDataFromXamarinObject(event.data);
                    });
                    // Bootstrap anti-course : le natif emet InitialiserLienWebView sur
                    // NavigationCompleted, parfois AVANT que ce listener soit arme (course au
                    // 1er load, et surtout apres un ViderCache/Reload ou le JS remonte non-cache
                    // donc plus lentement) -> le message est perdu et avecWebView reste false.
                    // Si c'est le cas, on demande au natif de re-emettre le lien d'init. Le delai
                    // evite de doubler l'init quand le 1er handshake a deja reussi.
                    setTimeout(() => {
                        if (!RequestManager.avecWebView) {
                            try { window.chrome.webview.postMessage({ action: 'FrontPret', parameters: [] }); } catch (e) { /* noop */ }
                        }
                    }, 800);
                }
                else {
                    RequestManager.estBrowser = false;

                }
            }

            this.verifierConnectionEtRedirigerVersTransCAM();
        },
        watch: {
            v: function (value) {
                //console.log("Wtach v : ", value);
            },

            connexionValeur: function (value) {
                if (value) {
                    this.$router.push({
                        name: this.estSessionLoginFisi() ? "ChoixAppli" : "TransCAM"
                    })
                }
                else {
                    this.$router.push({ name: 'Accueil' })
                }
                //console.log("connection = ", value);
            },

            appliLance(value) {
            },
        }
    }
</script>

<style>
    .NavBar {
        display: flex;
        margin: 15px;
        /*justify-content:space-between;*/
    }

        .NavBar > div > button {
            background-color: white;
            border-radius: 10px;
            border: hidden;
            text-align: center;
            padding: 10px;
            font-size: medium;
        }

    #app {
    }
</style>
